import React from "react";
import clsx from "classnames";
import classes from "./styles.module.scss";
import SourceFlowForm from "@sourceflow-uk/sourceflowform";
import HeaderTitle from "@/components/HeaderTitle";
import ContactButton from "@/components/ContactButton";
import { getGlobal } from "@/functions/getGlobal";
import { offices_helper } from "@/helpers/offices_helper";

export const Offices = ({ officeProp, className = "", form }) => {
  const global = getGlobal();
  const facebook = global["_theme.social.facebook"];
  const twitter = global["_theme.social.twitter"];
  const linkedin = global["_theme.social.linkedin"];
  const instagram = global["_theme.social.instagram"];

  // Resolve office prop: slug or object
  const allOffices = offices_helper.fetch();
  const selectedOffice = typeof officeProp === "string" ? offices_helper.find(officeProp) : officeProp;
  // Guard if not found
  const office = selectedOffice || allOffices[0];
  const formId = form || "fbdc1232-d601-45d2-9711-de1386f3cd89";
  return (
    <div className={clsx(className, classes.office)}>
      <div className={classes.left_section}>
        <div className={classes.title}>
          <HeaderTitle title={office.location} />
        </div>
        <div className={classes.office_detail}>
          <img className={classes.location_image} src={office.image?.en || office.image} alt={office.location} />
          <div className={classes.contact_detail}>
            <h6 className={classes.label}>Get in touch</h6>
            <div className={classes.contacts}>
              <div className={classes.icon}>
                <ContactButton
                  hoverType="dark"
                  buttonSize="48px"
                  iconSize="20px"
                  href={office.google_map_link?.en || office.google_map_link}
                  icon="/icons/location.png"
                  alt="location"
                />
                <a className={classes.address} href={office.google_map_link?.en || office.google_map_link}>
                  {office.address?.en || office.address}
                </a>
              </div>

              {office.email?.en && (
                <div className={classes.icon}>
                  <ContactButton
                    hoverType="dark"
                    buttonSize="48px"
                    iconSize="20px"
                    href={`mailto:${office.email.en}`}
                    icon="/icons/envelope.png"
                    alt="email"
                  />
                  <a className={classes.address} href={`mailto:${office.email.en}`}>
                    {office.email.en}
                  </a>
                </div>
              )}

              {office.phone?.en && (
                <div className={classes.icon}>
                  {office.url_slug !== "cape-town" && (
                    <>
                      <ContactButton
                        hoverType="dark"
                        buttonSize="48px"
                        iconSize="20px"
                        href={`tel:${office.phone.en}`}
                        icon="/icons/call.png"
                        alt="phone"
                      />
                      <a className={classes.address} href={`tel:${office.phone.en}`}>
                        {office.phone.en}
                      </a>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
        <div className={classes.socials}>
          {[linkedin, twitter, facebook, instagram].map((url, idx) => (
            <ContactButton
              key={idx}
              hoverType="dark"
              buttonSize="48px"
              iconSize="20px"
              href={url}
              icon={`/icons/${["linkedin", "twitter", "facebook", "instagram"][idx]}.png`}
              alt={["LinkedIn", "Twitter", "Facebook", "Instagram"][idx]}
            />
          ))}
        </div>
      </div>

      <div className={classes.right_section}>
        <h2 className={classes.enquiry_title}>Submit an enquiry</h2>
        <div className={classes.enquiry_subtitle}>For your general enquiries, please fill the form below</div>
        <SourceFlowForm onSubmitDone={() => (window.location.href = "/office-thank-you")} formId={formId} />
      </div>
    </div>
  );
};

export default Offices;
